@if (pageId !== cartPageId && inStockItems.length > 0 && backOrderItems.length > 0) {
<div class="checkout-stock-item-summary">
  <h3
    class="checkout-stock-item-summary-title"
    [innerHTML]="'cart.checkoutDetailsInstock.title' | cxTranslate : { item: inStockItems.length }"
  ></h3>
  <span class="checkout-stock-item-summary-desc">{{ 'cart.checkoutDetailsInstock.desc' | cxTranslate }}</span>
</div>
} @for (item of inStockItems; track item; let i = $index; let last = $last) {
<div class="item-list-row">
  @if (getControl(item) | async; as control) {
  <div class="item-list-items" [class.is-changed]="control.get('quantity').dirty || control.get('memo').dirty">
    <cx-cart-item
      [item]="item"
      [cartPageId]="cartPageId"
      [quantityControl]="control.get('quantity')"
      [memoControl]="control.get('memo')"
      [readonly]="false"
      [potentialProductPromotions]="getPotentialProductPromotionsForItem(item)"
      [promotionLocation]="promotionLocation"
      [options]="options"
      [pageId]="pageId"
      [lastItem]="last"
      [noStockError]="getCartError(item, 'noStock')"
      [lowStockError]="getCartError(item, 'lowStock')"
      [unapprovedError]="unapprovedError"
      [dealerSpinner]="dealerSpinner"
      [removeSpinner]="removeSpinner"
      [dateFormatted]="dateFormatted"
      [skipVariantCategory]="skipVariantCategory"
      [appliedPromotions]="appliedPromotions"
      [showWarehouseFeature]="showWarehouseFeature"
    >
    </cx-cart-item>
  </div>
  }
</div>
}

<!-- DISCONTINUED ITEMS - CART PAGE ONLY-->
@for (item of discontinuedItems; track item; let i = $index; let last = $last) {
<div class="item-list-row">
  @if (getControl(item) | async; as control) {
  <div class="item-list-items" [class.is-changed]="control.get('quantity').dirty || control.get('memo').dirty">
    <cx-cart-item
      [item]="item"
      [cartPageId]="cartPageId"
      [quantityControl]="control.get('quantity')"
      [memoControl]="control.get('memo')"
      [readonly]="false"
      [potentialProductPromotions]="getPotentialProductPromotionsForItem(item)"
      [promotionLocation]="promotionLocation"
      [options]="options"
      [pageId]="pageId"
      [lastItem]="last"
      [noStockError]="getCartError(item, 'noStock')"
      [lowStockError]="getCartError(item, 'lowStock')"
      [unapprovedError]="unapprovedError"
      [dealerSpinner]="dealerSpinner"
      [removeSpinner]="removeSpinner"
      [dateFormatted]="dateFormatted"
      [skipVariantCategory]="skipVariantCategory"
      [appliedPromotions]="appliedPromotions"
      [showWarehouseFeature]="showWarehouseFeature"
    >
    </cx-cart-item>
  </div>
  }
</div>
} @if (pageId !== cartPageId && inStockItems.length >= 0 && backOrderItems.length > 0) {
<div class="checkout-stock-item-summary backorder-summary">
  <h3
    class="checkout-stock-item-summary-title"
    [innerHTML]="'cart.checkoutDetailsBackorder.title' | cxTranslate : { item: backOrderItems.length }"
  ></h3>
  <span class="checkout-stock-item-summary-desc">{{ 'cart.checkoutDetailsBackorder.desc' | cxTranslate }}</span>
</div>
} @for (item of backOrderItems; track item; let i = $index; let last = $last) {
<div class="item-list-row">
  @if (getControl(item) | async; as control) {
  <div class="item-list-items" [class.is-changed]="control.get('quantity').dirty || control.get('memo').dirty">
    <cx-cart-item
      [item]="item"
      [cartPageId]="cartPageId"
      [quantityControl]="control.get('quantity')"
      [memoControl]="control.get('memo')"
      [readonly]="false"
      [potentialProductPromotions]="getPotentialProductPromotionsForItem(item)"
      [promotionLocation]="promotionLocation"
      [options]="options"
      [pageId]="pageId"
      [lastItem]="last"
      [noStockError]="getCartError(item, 'noStock')"
      [lowStockError]="getCartError(item, 'lowStock')"
      [unapprovedError]="unapprovedError"
      [dateFormatted]="dateFormatted"
      [skipVariantCategory]="skipVariantCategory"
      [appliedPromotions]="appliedPromotions"
      [showWarehouseFeature]="showWarehouseFeature"
    >
    </cx-cart-item>
  </div>
  }
</div>
}

<!-- FREE GIFTS - CART PAGE ONLY-->
@for (item of freeGifts; track item; let i = $index; let last = $last) {
<div class="item-list-row">
  @if (getControl(item) | async; as control) {
  <div class="item-list-items" [class.is-changed]="control.get('quantity').dirty || control.get('memo').dirty">
    <cx-cart-item
      [item]="item"
      [cartPageId]="cartPageId"
      [quantityControl]="control.get('quantity')"
      [memoControl]="control.get('memo')"
      [readonly]="false"
      [potentialProductPromotions]="getPotentialProductPromotionsForItem(item)"
      [promotionLocation]="promotionLocation"
      [options]="options"
      [pageId]="pageId"
      [lastItem]="last"
      [noStockError]="getCartError(item, 'noStock')"
      [lowStockError]="getCartError(item, 'lowStock')"
      [unapprovedError]="unapprovedError"
      [dateFormatted]="dateFormatted"
      [appliedPromotions]="appliedPromotions"
      [showWarehouseFeature]="showWarehouseFeature"
    >
    </cx-cart-item>
  </div>
  }
</div>
}

<!-- OUT OF STOCK ITEMS - CART PAGE ONLY-->
@for (item of outStockItems; track item; let i = $index; let last = $last) {
<div class="item-list-row">
  @if (getControl(item) | async; as control) {
  <div class="item-list-items" [class.is-changed]="control.get('quantity').dirty">
    <cx-cart-item
      [item]="item"
      [cartPageId]="cartPageId"
      [quantityControl]="control.get('quantity')"
      [readonly]="false"
      [potentialProductPromotions]="getPotentialProductPromotionsForItem(item)"
      [promotionLocation]="promotionLocation"
      [options]="options"
      [pageId]="pageId"
      [lastItem]="last"
      [noStockError]="getCartError(item, 'noStock')"
      [lowStockError]="getCartError(item, 'lowStock')"
      [unapprovedError]="unapprovedError"
      [dateFormatted]="dateFormatted"
      [appliedPromotions]="appliedPromotions"
      [showWarehouseFeature]="showWarehouseFeature"
    >
    </cx-cart-item>
  </div>
  }
</div>
}
